module.exports = __webpack_public_path__ + "img/ic-warning.be6f1638.svg";